import { SxProps } from '@mui/material';
import { SelectOption } from 'common/types/select-option';
import { FormikProps } from 'formik';
import { relative } from 'path/posix';
import React, { PropsWithChildren } from 'react';
import { WsFormNativeSelect } from 'stories/forms/WsFormNativeSelect';
import { WsFormTextField } from 'stories/forms/WsFormTextField';
import { WsNativeSelect } from 'stories/inputs/WsNativeSelect';
import WsInfoFrameLabel from 'stories/layout/WsInfoFrameLabel';
import WsInfoFrameRow from 'stories/layout/WsInfoFrameRow';

type ListingRowProps = {
  label: string;
  gridLR?: [number, number];
  gsx?: SxProps;
};

export const ListingRow = ({ label, children, ...props }: PropsWithChildren<ListingRowProps>) => {
  return (
    <WsInfoFrameRow gridLR={props.gridLR} sx={{ alignItems: 'center', paddingTop: 0.5, paddingBottom: 0.5 }} {...props}>
      <WsInfoFrameLabel label={label} />
      {children}
    </WsInfoFrameRow>
  );
};

type ListingSelectProps = {
  id: string;
  data: SelectOption[];
  width: number;
  value: string;
  disabled?: boolean;
  onChange: (id: string) => void;
};

export const ListingSelect = (props: ListingSelectProps) => {
  return (
    <WsNativeSelect
      width={props.width}
      id={props.id}
      fsx={{
        position: 'relative',
        top: '8px',
      }}
      data={props.data}
      onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(event.target.value)}
      value={props.value}
      disabled={props.disabled}
    />
  );
};

type ListingFormSelectProps = {
  id: string;
  data: SelectOption[];
  disabled?: boolean;
  width?: number;
  onChange?: (...args: any[]) => void;
  formik: FormikProps<any>;
};

export const ListingFormSelect = (props: ListingFormSelectProps) => {
  return (
    <WsFormNativeSelect
      width={props.width ? props.width : 150}
      fsx={{
        position: 'relative',
        top: '6px',
      }}
      disabled={props.disabled}
      {...props}
    />
  );
};

export type ListingFormTextFieldProps = {
  id: string;
  label?: string;
  currency?: boolean;
  disabled?: boolean;
  onChange?: (...args: any[]) => void;
  formik: FormikProps<any>;
  multiline?: boolean;
  rows?: number;
  maxRows?: number;
};

export const ListingFormTextField = (props: ListingFormTextFieldProps) => {
  return (
    <WsFormTextField
      type="text"
      size="small"
      currency={props.currency}
      label={props.label}
      width={120}
      sx={{
        position: 'relative',
        top: '12px',
      }}
      disabled={props.disabled}
      // onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.onChange(event, props.formik)}
      {...props}
    />
  );
};
